import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class BudgetClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async listar(params = {}) {
    try {
      const cleaned = {};
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      return await this.api.get('/budget', { params: cleaned });
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async buscarPorId(id) {
    try {
      return await this.api.get(`/budget/${id}`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async criar(payload) {
    try {
      return await this.api.post('/budget', payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async atualizar(id, payload) {
    try {
      return await this.api.put(`/budget/${id}`, payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async excluir(id) {
    try {
      return await this.api.delete(`/budget/${id}`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async listarSupervisores() {
    try {
      return await this.api.get('/budget/supervisores');
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async listarRepresentantes(supervisorid) {
    try {
      return await this.api.get(`/budget/supervisores/${supervisorid}/representantes`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async ajusteManual(id, payload) {
    try {
      return await this.api.post(`/budget/${id}/ajuste`, payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async transferir(id, payload) {
    try {
      return await this.api.post(`/budget/${id}/transferir`, payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async salvarAlocacoes(id, payload) {
    try {
      return await this.api.put(`/budget/${id}/alocacoes`, payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async dashboard() {
    try {
      return await this.api.get('/budget/dashboard');
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  // Saldo do próprio usuário (indicador de header). Falha silenciosa: o widget
  // simplesmente não aparece se a chamada der erro — sem popup de erro global.
  async meuSaldo() {
    return await this.api.get('/budget/meu-saldo');
  }

  // Pedidos (doações WD) que deram baixa no budget do próprio representante.
  async meusPedidos() {
    return await this.api.get('/budget/meus-pedidos');
  }

  // Pré-checagem do carrinho de doação (aviso antecipado de estouro por
  // categoria ELT/GL). Falha silenciosa: aviso simplesmente não aparece.
  async validarCarrinho(payload) {
    return await this.api.post('/budget/validar-carrinho', payload);
  }

  // ── Aprovador alternativo (delegação de supervisor) ────────────────────
  // Status do usuário logado: se É delegado de alguém (recebidas) e, sendo
  // supervisor, a delegação ativa que criou (minha) + histórico.
  async delegacaoStatus() {
    return await this.api.get('/budget/delegacao/status');
  }

  async delegacaoCandidatos() {
    return await this.api.get('/budget/delegacao/candidatos');
  }

  async criarDelegacao(payload) {
    try {
      return await this.api.post('/budget/delegacao', payload);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async encerrarDelegacao(delegacaoid) {
    try {
      return await this.api.delete(`/budget/delegacao/${delegacaoid}`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }
}
